import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { Loader2, LogIn } from "lucide-react";
import { useState } from "react";
import { authClient } from "#/lib/auth-client";
import { homeRouteFor } from "#/lib/roles";
import { getSession } from "#/lib/session";

export const Route = createFileRoute("/admin/login")({
	beforeLoad: async () => {
		const session = await getSession();
		if (session?.user) {
			throw redirect({ to: homeRouteFor(session.user.role) });
		}
	},
	component: AdminLogin,
});

function AdminLogin() {
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState<string | null>(null);
	const [isSubmitting, setIsSubmitting] = useState(false);

	async function handleSubmit(event: React.FormEvent) {
		event.preventDefault();
		setError(null);
		setIsSubmitting(true);

		const { data, error: signInError } = await authClient.signIn.email({
			email: email.trim(),
			password,
		});

		setIsSubmitting(false);

		if (signInError) {
			setError("البريد الإلكتروني أو كلمة المرور غير صحيحة.");
			return;
		}

		// A community manager has no dashboard to land on — send each role to
		// the first page it is actually allowed to open.
		void navigate({ to: homeRouteFor(data?.user?.role) });
	}

	return (
		<div className="mx-auto max-w-sm">
			<h1 className="mb-2 text-center text-2xl font-bold text-navy">
				تسجيل الدخول
			</h1>
			<p className="mb-8 text-center text-sm text-muted">
				فضاء خاص بفريق الإدارة لمتابعة طلبات التسجيل.
			</p>

			<form
				onSubmit={(e) => {
					void handleSubmit(e);
				}}
				className="flex flex-col gap-4 rounded-2xl border border-line bg-white p-8 shadow-card"
			>
				<div>
					<label
						htmlFor="email"
						className="mb-1.5 block text-sm font-bold text-navy"
					>
						البريد الإلكتروني
					</label>
					<input
						id="email"
						type="email"
						required
						autoComplete="email"
						dir="ltr"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						className="w-full rounded-xl border border-line px-4 py-3 text-base outline-none focus:border-teal focus:ring-4 focus:ring-teal/15"
					/>
				</div>
				<div>
					<label
						htmlFor="password"
						className="mb-1.5 block text-sm font-bold text-navy"
					>
						كلمة المرور
					</label>
					<input
						id="password"
						type="password"
						required
						autoComplete="current-password"
						dir="ltr"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						className="w-full rounded-xl border border-line px-4 py-3 text-base outline-none focus:border-teal focus:ring-4 focus:ring-teal/15"
					/>
				</div>

				{error ? (
					<p className="text-sm font-semibold text-red-600">{error}</p>
				) : null}

				<button
					type="submit"
					disabled={isSubmitting}
					className="mt-2 inline-flex items-center justify-center gap-2 rounded-xl bg-navy px-6 py-3.5 text-base font-bold text-white transition-colors hover:bg-navy-600 disabled:opacity-70"
				>
					{isSubmitting ? (
						<Loader2 className="h-5 w-5 animate-spin" />
					) : (
						<LogIn className="h-5 w-5" />
					)}
					دخول
				</button>
			</form>
		</div>
	);
}
